/* eslint-disable no-param-reassign */
// Utils
import { getFrom, shallowDifferences } from 'ezyvet-fe-helpers';
import { decommit } from '../decommit';
import { getCommitted } from '../getCommitted';
import { createObjectPaths } from '../../objectIdentity';
/**
 * For the given set of values, find all the added or removed objects, and added those to the given.
 * changes.
 *
 * @template T extends object
 * @param {T} value
 * @param {ChangeList} changes
 *
 * @return {void}
 */
export var addObjectAdditionsAndDeletionChanges = function (value, changes) {
    var committedValue = getCommitted(value);
    var objectPaths = createObjectPaths(value);
    var committedValueObjectPaths = createObjectPaths(committedValue);
    var _a = shallowDifferences(committedValueObjectPaths, objectPaths), deletedObjectIds = _a.deleted, addedObjectIds = _a.added;
    var deletedObject;
    deletedObjectIds.forEach(function (objectId) {
        deletedObject = getFrom(committedValue, committedValueObjectPaths[objectId]);
        changes[objectId] = [decommit(deletedObject), undefined];
    });
    var addedObject;
    addedObjectIds.forEach(function (objectId) {
        addedObject = getFrom(value, objectPaths[objectId]);
        changes[objectId] = [undefined, decommit(addedObject)];
    });
};
//# sourceMappingURL=addObjectAdditionsAndDeletionChanges.js.map